import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

export default function UnknownMessage() {
  const { t } = useTranslation();

  return (
    <div className="empty error">
      <strong>{t('error_unknown_title')}</strong>
      <p>
        <Trans i18nKey="error_unknown_description" />
      </p>
    </div>
  );
}
